export default {
    data() {
        return {
            subVersionKeyId: '',
            userTableData: [],
            lxTableHeader: [
                { prop: 'sortNo', label: this.$t('showLxRecord.XH'), width: 50 },
                { prop: 'playerName', label: this.$t('showLxRecord.XM'), width: 120 },
                { prop: 'playerNo', label: this.$t('showLxRecord.ID'), width: 170 },
                { prop: 'stationName', label: this.$t('showLxRecord.GW') },
                { prop: 'leaderFlagName', label: this.$t('showLxRecord.SF'), width: 50 },
                { prop: 'SystemScoring', label: this.$t('showLxRecord.SSPF'), width: 100},
                {prop: 'subjectiveScore', label: this.$t('showLxRecord.RGYJ'), width: 100 },
                { prop: 'score', label: this.$t('showLxRecord.FS'), width: 120 }
            ],
            lxTableHeaderPresion: [
                { prop: 'sortNo', label: this.$t('showLxRecord.XH'), width: 50 },
                { prop: 'playerName', label: this.$t('showLxRecord.XM') },
                { prop: 'playerNo', label: this.$t('showLxRecord.ID') },
                { prop: 'stationName', label: this.$t('showLxRecord.GW') }
            ],
            activeName: 'first',
            titleData: {

            },
            planData: {
                teamDto: {},
                playerDto: {}
            },
            paperData: {

            },
            loading: false,
            answerFlag: 0
        }
    },
    created() {
        let { answerFlag } = JSON.parse(this.__Base64.decode(this.$route.query.q))
        this.answerFlag = answerFlag
    },
    methods: {
        operation(type, rowData) {
            if (type === 'currentChange') {
                this.setPaperList(rowData)
            }
        },
        handleClick() {

        }
    },
}